export default {
  color: 'gammaRed',
  textDecoration: `none`,
  userSelect: `none`,
  cursor: `pointer`,
  transition: `all 250ms ease`,
  fontFamily: `Lato, sans-serif`,
  fontWeight: 700,
  marginLeft: `30px !important`,
  p: 0,
  ':hover': {
    color: 'gammaDarkRed',
    textDecoration: `underline !important`
  }
}
